import { mainApi } from '@/lib/api';
import type { BillingLinkResponse, RawCustomerDetails } from './types';
import type {
    InvoicePayload,
    ManageMembershipPayload,
    UpdateCustomerPayload,
} from '@/features/audience/types/customer';
import { mapCustomerDetails } from '@/features/audience/lib/audience.logic';
import { withTimezone } from '@/lib/date';

export async function fetchCustomerDetails(userFanId: number) {
    const { data } = await mainApi.get<RawCustomerDetails>(`v1/orders/fan/${userFanId}`, {
        params: withTimezone(),
    });
    return mapCustomerDetails(data, userFanId);
}

// Customer Actions API
export async function updateCustomer(userFanId: number, payload: UpdateCustomerPayload): Promise<void> {
    await mainApi.patch(`v1/users/fans/${userFanId}`, {
        full_name: payload.fullName,
        email: payload.email,
        phone_number: payload.phoneNumber,
    });
}

export async function deleteCustomer(userFanId: number): Promise<void> {
    await mainApi.delete(`v1/users/fans/${userFanId}`);
}

export async function sendInvoice(userFanId: number, payload: InvoicePayload): Promise<void> {
    await mainApi.post(`v1/orders/fan/${userFanId}/invoice`, {
        product_name: payload.description,
        amount: payload.amount,
        ...withTimezone(),
    });
}

export async function manageMembership(payload: ManageMembershipPayload): Promise<void> {
    await mainApi.post('v1/membership/manage', {
        action: payload.action,
        subscription_id: payload.subscriptionId,
    });
}

export async function createBillingLink(subscriptionId: string): Promise<string> {
    const { data } = await mainApi.post<BillingLinkResponse>(`v1/membership/${subscriptionId}/billing-link`);
    return data.link;
}

// Tags API
export async function fetchAvailableFanTags(): Promise<string[]> {
    const { data } = await mainApi.get<{ tags: string[] }>('v1/tags/fan-tags-list');
    return data.tags;
}

export async function fetchFanTags(userFanId: number): Promise<string[]> {
    const { data } = await mainApi.get<{ tags: string[] }>(`v1/tags/fan-tags/${userFanId}`);
    return data.tags;
}

export async function createFanTag(userFanId: number, name: string): Promise<void> {
    await mainApi.post('v1/tags/fan-tags', {
        user_fan_id: userFanId,
        name,
    });
}

export async function deleteFanTag(userFanId: number, name: string): Promise<void> {
    await mainApi.delete('v1/tags/fan-tags', {
        params: {
            user_fan_id: userFanId,
            name,
        },
    });
}
